import Scratch3AiBlocks from '../extensions/scratch3_ai/index.js';
import Scratch3ReachyBlocks from '../extensions/scratch3_reachy/index.js';

/**
 * Rozšírenia, ktoré žijú v scratch-gui (nie v scratch-vm).
 *
 * Vyberajú sa z galérie rozšírení rovnako ako vstavané, ale scratch-vm o nich
 * nevie — musíme ich zaregistrovať sami.
 */
const guiBuiltinExtensions = {
    aiBlocks: Scratch3AiBlocks,
    reachyBlocks: Scratch3ReachyBlocks
};

/**
 * Tie z nich, ktoré scratch-vm nemá ani vo svojom zozname vstavaných.
 *
 * Bez nich by sa uložený projekt s takýmito blokmi nedal načítať: pri
 * načítaní `.sb3` volá VM `loadExtensionURL(id)` a pre neznáme id skúša
 * stiahnuť rozšírenie ako URL vo worker-i — čo zlyhá. `aiBlocks` v zozname
 * nie je, lebo tú verziu má scratch-vm vlastnú.
 */
const guiOnlyExtensionIds = ['reachyBlocks'];

/**
 * Zaregistruj rozšírenie do bežiacej VM a vráť true, ak sa to podarilo.
 * @param {object} vm - inštancia scratch-vm
 * @param {string} id - id rozšírenia, napr. 'reachyBlocks'
 * @returns {boolean} - či je rozšírenie po volaní načítané
 */
const loadGuiBuiltinExtension = function (vm, id) {
    const ExtensionClass = guiBuiltinExtensions[id];
    if (!ExtensionClass) return false;
    if (vm.extensionManager.isExtensionLoaded(id)) return true;

    const instance = new ExtensionClass(vm.runtime);
    const serviceName = vm.extensionManager._registerInternalExtension(instance);
    vm.extensionManager._loadedExtensions.set(id, serviceName);
    return true;
};

/**
 * Nauč VM načítať naše rozšírenia aj pri otváraní uloženého projektu.
 *
 * Zasahuje len do id-čiek zo `guiOnlyExtensionIds`; všetko ostatné ide
 * pôvodnou cestou.
 * @param {object} vm - inštancia scratch-vm
 */
const installGuiBuiltinExtensions = function (vm) {
    if (!vm || !vm.extensionManager || vm.extensionManager._guiBuiltinsInstalled) return;
    vm.extensionManager._guiBuiltinsInstalled = true;

    const povodne = vm.extensionManager.loadExtensionURL.bind(vm.extensionManager);
    vm.extensionManager.loadExtensionURL = function (extensionURL) {
        if (guiOnlyExtensionIds.indexOf(extensionURL) !== -1) {
            loadGuiBuiltinExtension(vm, extensionURL);
            return Promise.resolve();
        }
        return povodne(extensionURL);
    };
};

export {
    guiBuiltinExtensions,
    guiOnlyExtensionIds,
    loadGuiBuiltinExtension,
    installGuiBuiltinExtensions
};
